import { AppThunk } from '../../../../store/types';
import { Navigator } from '../../../../effects/navigator';
import { PlayerController } from '../../../../effects/player/manager/playerController';

export class PastLessonsButtonEvents {

	// Same as opening a recording from the home page; the call itself stays up (CallApp is always mounted).
	public static onOpen(
		groupId: number,
		audioId: number,
	): AppThunk {
		return () => {
			PlayerController.getInstance().resetMode();
			Navigator.openAudio(groupId, audioId);
		};
	}

}
